<template>
  <div class="sidebar fl">
      <ul>
          <li v-for="(item, index) in itemsList" :key="index" :class="{'active': $route.params.name===item.name}">
              <a :href="`/gotoContent/${item.name}`">{{item.linkItem}}</a>
          </li>
      </ul>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  data () {
      return {
          itemsList: [
              {
                 linkItem: '亚商简介',
                 name: 'introduce'
              },
              {
                 linkItem: '发展历程',
                 name: 'developHistory'
              },
              {
                 linkItem: '核心团队',
                 name: 'founder'
              },
              {
                 linkItem: '联系我们',
                 name: 'contactUs'
              },
              {
                 linkItem: '加入我们',
                 name: 'joinUs'
              }
          ]
      }
  }
}
</script>

<style scoped>
.sidebar{
    width: 180px;
    /*height: 220px;*/
    background: #fff;
    padding: 25px 0;
    box-sizing: border-box;
    border: 1px solid #ced7e2;
}
.sidebar li{
    color: #ADBCD0;
    line-height: 45px;
}
.sidebar .active a{
    color: #003B83;
    font-weight: 600;
}
.router-link-active{
    color: #003B83;
    font-weight: 600;
}
</style>






// WEBPACK FOOTER //
// src/components/sidebar/Sidebar.vue